import { CompartmentCard } from "@/src/components/cards";
import { FetchableList } from "@/src/components/fetchableLists";
import { Reference } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, openToast, uid } from "@/src/utils/utils";
import { useState } from "react";
import { AdminDocumentTemplateCard } from "./adminDocumenTemplateCard";
import { openDocumentTemplatePicker } from "./adminDocumentTemplatesPicker";

export function ReferenceAssociatedDocuments({
  reference,
}: {
  reference: Reference;
}) {
  let [searchKey, setSearchKey] = useState("");
  const [reload, setReload] = useState(0);

  return (
    <CompartmentCard
      title={"Documents associés"}
      searchKey={searchKey}
      onSearch={(newValue) => {
        setSearchKey(newValue || "");
      }}
      onClick={async () => {
        await openDocumentTemplatePicker({
          onSelect: async (template) => {
            if (getItemId(template.reference) === getItemId(reference)) {
              openToast(
                "error",
                "Ce document est déjà associé à ce formulaire"
              );
              return;
            }
            template.reference = reference;
            await apiFetch("documentTemplates", "addOne", {
              documentTemplate: template,
            });
            setReload(reload + 1);
          },
        });
      }}
    >
      <FetchableList
        queryKey={[
          "ReferenceAssociatedDocuments",
          searchKey,
          getItemId(reference),
          reload,
        ]}
        queryFn={() =>
          apiFetch("documentTemplates", "loadMany", {
            types: ["standard"],
            referenceId: getItemId(reference),
          })
        }
      >
        {(data) => (
          <div className={`usersList grid c1 mc1 gap10`}>
            {data?.map((documentTemplate) => {
              return (
                <AdminDocumentTemplateCard
                  key={uid()}
                  documentTemplate={documentTemplate}
                  onChange={(newValue) => {
                    setReload(reload + 1);
                  }}
                  onDelete={async (e) => {
                    documentTemplate.reference = getItemId("references:none");
                    await apiFetch("documentTemplates", "addOne", {
                      documentTemplate,
                    });
                    setReload(reload + 1);
                  }}
                ></AdminDocumentTemplateCard>
              );
            })}
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}
